import React from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Inventory from "./pages/Inventory";
import NoPageFound from "./pages/NoPageFound";
import AuthContext from "./AuthContext";
import ProtectedWrapper from "./ProtectedWrapper";
import { useEffect, useState } from "react";
import Store from "./pages/Store";
import User from "./pages/UserPage";
import RFIPage from "./pages/RFIPage";
import UserDetails from './components/Details/UserDetails'
import ProjectDetails from './components/Details/ProjectDetails'
import IssuesPage from './pages/Issues'
import AltertsPage from './pages/Alerts'
import ViewFolders from './components/Details/Folders/ViewFolders'
import Meetings from  './pages/Meetings'
import QAPage from './pages/QAPage'
import Reports from "./components/Reports/ViewReports"
import {Loader} from '@mantine/core'
import "leaflet/dist/leaflet.css";
const App = () => {
  const [user, setUser] = useState(null)
  const [loader, setLoader] = useState(true);
  let myLoginUser = JSON.parse(localStorage.getItem("user"));
  // console.log("USER: ",user)
  useEffect(() => {
    if (myLoginUser) {
      setUser(myLoginUser.name);
      setLoader(false);
      //console.log("inside effect", myLoginUser)
    } else {
      setUser("");
      setLoader(false);
    }
  }, [myLoginUser]);

  const signin = (newUser, callback) => {
    setUser(newUser);
    callback();
  };
//console.log(user)
  const signout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    localStorage.removeItem("AllFilesState");
    localStorage.removeItem("currentPath")
    localStorage.removeItem("avatarColor-1")
    window.location.href = '/login'
  };

  let value = { user, signin, signout };

  if (loader)
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader type="ThreeDots" color="#00BFFF" size="xl" />

      </div>
    );

  return (
    <BrowserRouter>
      <AuthContext.Provider value={value}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedWrapper>
                <Layout />
              </ProtectedWrapper>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="/Projects" element={<Inventory />} />
            <Route path="/Rfis" element={<RFIPage />} />
            <Route path="/Users" element={<User />} />
            <Route path="/Users/Details" element={<UserDetails />} />
            <Route path="/Projects/Details" element={<ProjectDetails />} />
            <Route path="/Documentations" element={<Store />} />
            <Route path="/Issues" element={<IssuesPage />} />
            <Route path="/Alerts" element={<AltertsPage />} />
            <Route path="/Projects/Folders" element={<ViewFolders />} />
            <Route path='/Meetings' element={<Meetings/>}/>
            <Route path='/QA' element={<QAPage/>}/>
            <Route path="/Reports" element={<Reports/>}/>
          </Route>
          <Route path="*" element={<NoPageFound />} />
        </Routes>
      </AuthContext.Provider>
    </BrowserRouter>
  );
};

export default App;
